export interface OrderHead {
  orderheads_id: number;
  orderheads_code: string;
  orderheads_Yarncomp: string;
  orderheads_Yarncount: string;
  clt_name: string;
  orl_style_description: string;
  orl_gauge_code: string;
  orl_style_code: string;
  orl_quantity: number;
  orl_id: number;
}
export interface IOrderHead {
  orderheads_id: number;
  orderheads_code: string;
  orderheads_Yarncomp: string;
  orderheads_Yarncount: string;
  orderheads_client_id: number;
  clt_id: number;
  clt_code: string;
  clt_name: string;
  orl_id: number;
  orl_style_code: string;
  orl_style_description: string;
  orl_quantity: number;
  orl_factory1: string;
  orl_factory2: string;
  orl_gauge_code: string;
  orl_orderhead_id: number;
}
export interface IWeight {
  Size: string;
  GrmtWght: number;
  AllocWght: number;
}
export interface ICsb {
  Size: string;
  Qty: number;
  QtyKnitted:number;
}
export interface IColorDetail {
  ColorName: string;
  ColorCode: string;
  DyeLot: string;
}
export interface IDetailsOrder {
  ColorNum: number;
  TotalQuantityExtra: number;
  YrnReqWght: number;
  YrnAllocWght: number;
  YrnBalWght: number;
  YrnReceivedPercent:number;
  ColorDetails: Array<IColorDetail>;
  Csb: Array<ICsb>;
}
export interface WAFormData {
  orderId?: string | null;
  id_orderhead: number;
  id_orderlines: number;
  composition: string;
  yarnCount: string;
  customer: string;
  description: string;
  section: string;
  needle: string;
  quantity: number;
  style: string;
  deliveryDate: string;
  sizeNumber: number;
  colorNumber: number;
  multicolorNumber: number;
  bundledCost: number;
  smv: number;
  wt_tolerance: number;
  yarn_date: string;
  end_knit_date: string;
  machine_type?: string;
  weight: Array<IWeight>;
  detOrder: Array<IDetailsOrder>;
  type: string;
  external_order: boolean;
  additional_info: string;
  smc: ISmcData;
}

export interface ISmcData {
  knitting: number;
  gip: number;
  looping: number;
  stitching: number;
  labeling: number;
  SewingHalfmoon: number;
  mchEmbroidery: number;
  handEmbroidery: number;
  pressing_1: number;
  buttonHoles: number;
  buttonSew: number;
  zipper: number;
  hotFix: number;
  elbowPatch: number;
  stitchingFinition: number;
  inspection_1: number;
  pressing_2: number;
  inspection_2: number;
  folding: number;
}

interface InputFieldOptions {
  value: string;
  label: string;
  id: number;
}

interface InputField {
  label: string;
  field: string;
  hidden?: boolean;
  type?: string;
  disable?: boolean;
  required?: boolean;
  options?: InputFieldOptions[];
}

export const initialSmcData: ISmcData = {
  knitting: 0, 
  gip: 0, 
  looping: 0, 
  stitching: 0, 
  labeling: 0,
  SewingHalfmoon: 0, 
  mchEmbroidery: 0, 
  handEmbroidery: 0, 
  pressing_1: 0,
  buttonHoles: 0, 
  buttonSew: 0, 
  zipper: 0, 
  hotFix: 0, 
  elbowPatch: 0,
  stitchingFinition: 0, 
  inspection_1: 0, 
  pressing_2: 0, 
  inspection_2: 0,
  folding: 0,
};

export const initialStateFormData: WAFormData = {
  id_orderhead: 0,
  id_orderlines: 0,
  composition: "",
  yarnCount: "",
  customer: "",
  description: "",
  section: "",
  needle: "",
  quantity: 0,
  style: "",
  deliveryDate: "",
  sizeNumber: 0,
  colorNumber: 0,
  multicolorNumber: 1,
  bundledCost: 0,
  machine_type: "",
  smv: 0,
  weight: [],
  detOrder: [],
  wt_tolerance: 0,
  yarn_date: "",
  end_knit_date: "",
  type: "none",
  external_order: false,
  additional_info: "",
  orderId: "",
  smc: initialSmcData,
};

export interface WAInput {
  id_orderhead: number;
  id_orderlines: number;
  customer: string;
  needle: string;
  composition: string;
  yarnCount: string;
  description: string;
  section: string;
  quantity: number;
  size_number: number;
  color_number: number;
  multi_color_number: number;
  bundle_coef: number;
  smv: number;
  delivery_date: string;
  wt_tolerance: number;
  yarn_date: string;
  end_knit_date: string;
  machine_type?: string;
  weight: IWeight[];
  detOrder: IDetailsOrder[];
  NumOrder?: string;
  external_order: boolean;
  additional_info?: string;
  smc?: ISmcData;
  type:string;
  style: string;
}
export interface IErrorWA {
  deliveryDate: boolean;
  sizeNumber: boolean;
  colorNumber: boolean;
  multicolorNumber: boolean;
  bundledCost: boolean;
  smv: boolean;
  yarn_date: boolean,
  end_knit_date:boolean,
  [key: string]: any;
  weight: Array<number>;
  style: boolean;
}

export const initialError: IErrorWA = {
  deliveryDate: false,
  sizeNumber: false,
  colorNumber: false,
  multicolorNumber: false,
  bundledCost: false,
  smv: false,
  yarn_date: false,
  end_knit_date:false,
  style: false,
  weight: []
};

export const initialScanInputValue: IScanInput = {
  value: "",
  process: 1,
  RejProc:0,
  OutProcess:0,
  step: 1,
  substep: [],
  matric: "",
  machine: "",
  commentaire:"",
  Terminal: "Terminal",
};
export const initialScanNotifValue: IScanNotif = {
  message: "Ready to scan / Afaka manomboka ny scan",
  color: "success.main",
  variant: "indeterminate",
  progress: 0,
};
export const all_fields: Array<InputField> = [
  { label: "Composition", field: "composition", disable: true },
  { label: "Yarn Count", field: "yarnCount", disable: true },
  { label: "Customer", field: "customer", disable: false },
  { label: "Description", field: "description", disable: true },
  { label: "Needle", field: "needle", disable: true },
  { label: "Qty", field: "quantity", type: "number" },
  { label: "Style", field: "style", disable: true },
  { label: "Delivery Date", field: "deliveryDate", type: "date" },
  { label: "Color Number", field: "colorNumber", type: "number" },
  { label: "Size Number", field: "sizeNumber", type: "number" },
  { label: "Multicolor Number", field: "multicolorNumber", type: "number" },
  { label: "Bundled Cost (min)", field: "bundledCost", type: "number" },
  { label: "SMV min", field: "smv", type: "number" },
  { label: "WT Tolerance", field: "wt_tolerance", type: "number" },
  { label: "SECTION", field: "section" },
  { label: "Additional info", field: "additional_info", required: false },
  { label: "Yarn date", field: "yarn_date", type: "date" },
  { label: "End Knit date", field: "end_knit_date", type: "date" },
  {
    label: "Type",
    field: "type",
    type: "select",
    options: [
      {
        value: "none",
        label: "none",
        id: 1,
      },
      {
        value: "sample",
        label: "sample",
        id: 2,
      },
      {
        value: "testing",
        label: "testing",
        id: 3,
      },
      {
        value: "shipment",
        label: "shipment",
        id: 4,
      },
      {
        value: "photo",
        label: "photo",
        id: 5,
      },
      {
        value: "sms",
        label: "sms",
        id: 6,
      },
      {
        value: "surp",
        label: "surp",
        id: 7,
      },
      {
        value: "add",
        label: "add",
        id: 8,
      },
      {
        value: "dye",
        label: "dye",
        id: 9,
      },
      {
        value: "reject",
        label: "reject",
        id: 10,
      },
      {
        value: "piecedye",
        label: "piecedye",
        id: 11,
      },
      {
        value: "yarndye",
        label: "yarndye",
        id: 12,
      },
      {
        value: "reknit",
        label: "reknit",
        id: 13,
      },



    ],
  },
  {
    label: "Machine",
    field: "machine_type",
    type: "select",
    required: false,
    options: [],
  },
];

export const all_smc_fields: Array<InputField> = [
  { label: "Knitting", field: "knitting", type: "number" },
  { label: "Gip", field: "gip", type: "number" },
  { label: "Looping", field: "looping", type: "number" },
  { label: "Stitching", field: "stitching", type: "number" },
  { label: "Labeling", field: "labeling", type: "number" },
  { label: "Sewing halfmoon", field: "SewingHalfmoon", type: "number" },
  { label: "M/C embroidery", field: "mchEmbroidery", type: "number" },
  { label: "Hand embroidery", field: "handEmbroidery", type: "number" },
  { label: "1st pressing", field: "pressing_1", type: "number" },
  { label: "Button holes", field: "buttonHoles", type: "number" },
  { label: "Button sew", field: "buttonSew", type: "number" },
  { label: "Zipper", field: "zipper", type: "number" },
  { label: "Hot fix", field: "hotFix", type: "number" },
  { label: "Elbow patch", field: "elbowPatch", type: "number" },
  { label: "Stitching Finition", field: "stitchingFinition", type: "number" },
  { label: "1st Inspection", field: "inspection_1", type: "number" },
  { label: "2nd pressing", field: "pressing_2", type: "number" },
  { label: "2nd Inspection", field: "inspection_2", type: "number" },
  { label: "Folding", field: "folding", type: "number" },

];

export interface IOrderPdms {
  NumOrder: string;
  Customer: string;
  Style: string;
  Qty: number;
  Needle: number;
  YrnCnt: string;
  Composition: string;
  Descri: string;
  Section: string;
  DeliveryDate: string;
  Smv: number;
  BdlRatio: number;
  Pdms: string;
  Smv1: number;
  Canceled: string;
  created_at:string;
}

export interface ICsbSkeletonColor {
  ColorNum: number;
  ColorDetails: Array<{
    ColorName: string;
    ColorCode: string;
    DyeLot: string;
  }>;
  Csb: Array<{
    Size: string;
    Qty: number;
  }>;
}

export interface ICsbSkeleton {
  Csb: ICsbSkeletonColor[];
}

export interface IScannedPieceSummaryItem {
  ColorNum: number;
  Size: string;
  Qty: number;
}

export interface IScannedPieceSummary {
  PdmsCode: string;
  ProcessCode: number;
  Scanned: IScannedPieceSummaryItem[];
}

export interface ILeftOverDetailInput {
  numOrder: string;
  colorNum: number;
  size: string;
  quantity: number;
}

export interface ILeftOverDetailRecord extends ILeftOverDetailInput {
  color: string;
}

export interface ICreateLeftOverInput {
  matricule: string;
  destination: string;
  comment?: string;
  processCode: number;
  details: ILeftOverDetailInput[];
}

export interface ILeftOverRecord {
  id: number;
  orders: string[];
  style: string;
  pdmsCodes: string[];
  section: {
    processCode: number;
    processName: string;
  };
  matricule: string;
  createdBy: string;
  destination: string;
  comment: string;
  totalQuantity: number;
  details: ILeftOverDetailRecord[];
  createdAt: string;
}

export interface IQuantityTakenTicket {
  barcode: string;
  ordercod: string;
  tixno: number;
  pcsno?: number;
  numOrder: string;
  style?: string;
  colorNum: number;
  colorCode?: string;
  colorName: string;
  size: string;
  quantity: number;
}

export interface IQuantityTakenDetail {
  numOrder: string;
  colorNum: number;
  colorName: string;
  size: string;
  quantity: number;
  pdmsCode?: string;
  style?: string;
}

export interface IQuantityTakenRecord {
  id: number;
  matricule: string;
  createdBy: string;
  process: {
    processCode: number;
    processName: string;
  };
  comment: string;
  createdAt: string;
  returnedBy: string | null;
  returnedAt: string | null;
  returnTarget: {
    process: number;
    processName: string;
    step: number;
    stepName: string;
  } | null;
  totalQuantity: number;
  tickets: IQuantityTakenTicket[];
  details: IQuantityTakenDetail[];
}

export interface IScannedParameters {
  terminal: string;
  process: number;
  step: number;
  date_scan?: string;
  search?:string;
}
export interface IScanInput {
  value: string;
  process: number;
  RejProc?:number;
  OutProcess?:number;
  step: number;
  substep: string[];
  matric: string;
  RejID?:  {
    label: string;
    labelFR: string;
    labelMG: string;
    value: string 
  };
  operationType?:{
    value:number;
  };
  machine?: string;
  Terminal: string;
  commentaire:string;
  
}
export interface IScanNotif {
  variant: string;
  progress: number;
  message: string;
  color: string;
}
export interface IScanBody {
  ordercod: string;
  tixno: number;
  pcsno: number;
  value: string;
  process: number;
  step: number;
  substep: string;
  matric: string;
  Terminal: string;
  error: string;
  machine?: string;
  RejID?: string;
  RejProc?:number;
  OutProcess?:number;
  RejOpType?:number;

}
export interface IBulkScanInput {
  scans: IScanBody[];
}
export interface IBulkScanResult {
  requested: number;
  completed: number;
  scanned: IScannedTicket[];
  failed: Array<{ code: string; error: string }>;
}
export interface IScannedTicket {
  mysql_id?: number | string;
  ordercod: string;
  tixno: number;
  pcsno: number;
  process: number;
  step: number;
  substep: number;
  matric: string;
  scanned: string;
  auto: string;
  entby: string;
  Terminal: string;
  Insp: string;
  isTemporary?: boolean;
}
export interface IScanError {
  message: string;
  code?: string;
}
export interface IActivateScanInput {
  ordercod: string;
  tixno?: number;
  pcsno?: number;
  process: number;
  step: number;
  markAsFailed?: boolean;
}
export interface IActivateScanBulkInput {
  process: number;
  step: number;
  targets: Array<Pick<IActivateScanInput, "ordercod" | "tixno" | "pcsno">>;
}
export interface ICompiledProcessRouting {
  processManagement: unknown[];
  compiledRouting: any;
}
export interface IProcessLIst {
  id:number;
  ProcessCode: number;
  ProcessName: string;
}

export interface IMachineKnits {
  Mc_ID: string;
  Cell: string;
}
export interface IOperatorKnits {
  Op_ID: string;
  Cell: string;
}
export interface IRejectionType {
  RejID: string;
  RejName: string;
  RejDept: string;
  Process: number;
  Step: number;
  substep: string;
  RejNameFR: string;
  RejNameMG: string;
}
export interface ICreateRejectionType {
  RejName: string;
  RejNameFR: string;
  RejNameMG: string;
  RejDept: string;
  Process: number;
  Step: number;
  substep: string;
}
export interface IPrintInfo {
  speed_print: number;
  density_print: number;
  print_length: number;
  tixno_start: number;
  tixno_end: number | null;
  excluded_tickets: number[];
  selected_pieces?: string;
}
export const initialPrintInfo: IPrintInfo = {
  speed_print: 6,
  density_print: 20,
  print_length: 1800,
  tixno_start: 1,
  tixno_end: null,
  excluded_tickets: [],
  selected_pieces: undefined,
};

export interface IRejectedTicketList {
  ordercod: string;
  tixno: number;
  pcsno: number;
  process: number;
  step: number;
  substep: string | null;
  matric: string;
  scanned: string;
  entby: string;
  RejProc: number;
  ReturnedON: string;
  ProcessName: string;
  Terminal: string;
  RejID: null;
  RejName: null;
  RejNameFR: null;
  RejNameMG: null;
}

export interface UpdateReturnHistoryParams {
  bundleSeq: string;
  data: {
    IssuedWght: number;
    IssuedConesNbr: number;
    NumMch?: string;
    RetBundleQty: number;
    RejectPaneWght: number;
    RetPanelWght?: number;
    NumOprt: string;
    NumRetOprt?:string;
    RetYrnFromMch?:number;
    RetConeNbr?:number;
    Livreur?:string;
  };
}

interface IProcessConfig {
  processName: string;
  allowedActions: string[];
}

export interface IProcessRadioConfig {
  [key: string]: IProcessConfig;
}


export interface fetchPdmsDataParams{
   page?: number;
  limit?: number;
  search?: Record<string, any>;
  filters?: Record<string, any>;
  sort?: string;
  global_search?: string;
}

export interface SelectOptionType {
  label: string;
  value: number | string;
}

export type MachineStatus = 'available' | 'repair' | 'decommissioned' | 'other';

export interface IKnittingMachine {
  Mc_ID: string;
  N_serie: string;
  Type: string;
  Annee: string;
  Modele: string;
  Gauge: string;
  Machine: string;
  is_available: boolean;
  Location: string;
}

export interface IKnittingMachineHistory {
  id: number;
  Mc_ID: string;
  status: MachineStatus;
  reason: string | null;
  operator: string;
  created_at: string;
}

export interface IKnittingMachineDetail {
  machine: IKnittingMachine;
  history: IKnittingMachineHistory[];
}

export interface ICreateKnittingMachine {
  Mc_ID: string;
  N_serie: string;
  Type: string;
  Annee: string;
  Modele: string;
  Gauge: string;
  Machine: string;
  is_available?: boolean;
  Location: string;
}

export interface IUpdateKnittingMachine {
  N_serie?: string;
  Type?: string;
  Annee?: string;
  Modele?: string;
  Gauge?: string;
  Machine?: string;
  is_available?: boolean;
  status?: MachineStatus;
  reason?: string;
  Location?: string;
}

 interface IOptionalScanStep {
  id: string | number;
  code: string;
  label: string;
  requiresMachine: boolean;
  isOptional: boolean;
  isFinal: boolean;
  isReject: boolean;
}

export interface IOptionalScanProcess {
  id: string | number;
  processCode: string | number;
  processName: string;
  active: boolean;
  optional: boolean;
  steps: IOptionalScanStep[];
}

export interface ICurrentProcessTicket {
  code?: string | number;
  ticket?: string | number | Record<string, unknown>;
  piece?: string | number | Record<string, unknown>;
}
